module.exports = __webpack_public_path__ + "static/media/instagram-icon.f867f575.svg";